import type { ModuleDefinition } from '../types';

export const identityModule: ModuleDefinition = {
  key: 'identity',
  milestone: 'M2',
  network: { path: 'identity', permission: 'identity.user.manage', labelKey: 'identity' },
  tenant: { path: 'identity', permission: 'identity.user.manage.tenant', labelKey: 'identity' },
  load: () => import('./IdentityModule'),
};
